import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { StoreBadges } from '../components/StoreBadges';
import { WEB_JOIN_URL, SUPPORT_EMAIL } from '../data/launch';
const links = [{
  to: '/faq',
  label: 'Frequently asked questions'
}, {
  to: '/about',
  label: 'About KittyPot'
}, {
  to: '/contact',
  label: 'Contact us'
}, {
  to: '/delete-account',
  label: 'Delete your account'
}];
export function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-587" data-mp="1jv58w11hom79">
      <SEO title="Page not found | KittyPot" description="That page does not exist. Head back to KittyPot to track shared expenses and see who owes whom." ogTitle="Page not found" ogDescription="That page does not exist on kittypot.com." path="/404" noIndex data-id="element-588" data-mp="1nuxh2cmz0qc3" />
      <Navbar data-id="element-589" data-mp="1ntr79gn7skhc" />
      <main className="pt-36 pb-24" data-id="element-590" data-mp="1iwr1z7y6vlra">
        <div className="max-w-3xl mx-auto px-6 sm:px-8" data-id="element-591" data-mp="1iwhje5fh4gvm">
          <p className="mb-4 text-sm font-black uppercase tracking-widest text-kitty-yellow-700" data-id="element-592" data-mp="1iz3qk3ygcudb">
            404
          </p>
          <h1 className="mb-5 text-4xl md:text-5xl font-black tracking-tight text-kitty-dark" data-id="element-593" data-mp="19wm4bpiss1qb">
            That page has gone walkabout.
          </h1>
          <p className="mb-10 max-w-xl text-lg text-gray-600" data-id="element-594" data-mp="26og054xoz4g5">
            The link might be out of date, or we may have moved the page. Here
            is the way back.
          </p>

          <Link to="/" className="inline-flex min-h-[56px] items-center justify-center rounded-full bg-kitty-yellow px-8 text-base font-bold text-kitty-dark shadow-md transition-colors duration-150 hover:bg-kitty-yellow-500 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-dark focus-visible:ring-offset-2" data-id="element-595" data-mp="1xsgsnjebkn2c">
            Back to the homepage
          </Link>

          <div className="mt-12 grid gap-8 sm:grid-cols-2" data-id="element-596" data-mp="34i7aiy1xhjpn">
            <div data-id="element-597" data-mp="39eftkmj8xx23">
              <h2 className="mb-4 text-lg font-bold text-kitty-dark" data-id="element-598" data-mp="39h20cjybc8j9">
                Looking for something else?
              </h2>
              <ul className="space-y-3" data-id="element-599" data-mp="2zowbhj3cy78a">
                {links.map(link => <li key={link.to} data-id="element-600" data-mp="2zmrz0cre7zwe">
                    <Link to={link.to} className="font-semibold text-gray-700 underline underline-offset-4 transition-colors duration-150 hover:text-kitty-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-601" data-mp="2lp3kdmnx5ozs">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-602" data-mp="av7i2t0xpwov">
              <h2 className="mb-4 text-lg font-bold text-kitty-dark" data-id="element-603" data-mp="eyx3j9mbby5o">
                Been invited to a kitty?
              </h2>
              <p className="mb-4 text-base leading-relaxed text-gray-600" data-id="element-604" data-mp="1zg6ct12j37r8">
                Invite links open at{' '}
                <a href={WEB_JOIN_URL} target="_blank" rel="noopener noreferrer" className="font-bold text-kitty-dark underline underline-offset-4 transition-colors duration-150 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-605" data-mp="1vgnpjyn8ikl8">
                  our join page
                </a>
                . If your link or code has stopped working, ask whoever
                organised the kitty to send it again, or email{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="font-bold text-kitty-dark underline underline-offset-4 transition-colors duration-150 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-606" data-mp="2n6s7zrrfoxjt">
                  {SUPPORT_EMAIL}
                </a>
                .
              </p>
              <StoreBadges tone="light" data-id="element-607" data-mp="z8rgcefhx7z6" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-608" data-mp="147um613avi87" />
    </div>;
}